<template>
    <div class="game-info-obj-card" :class="classMap[type]">
      <div class="default-size" :class="currentQulity">
        <div class="mask" v-if="type == 1 || type == 2">
          <img :src="src" />
        </div>
        <div class="simple-img" v-else>
          <img
            v-lazy="sourceBg"
            v-if="sourceBgType != null || sourceBgType != undefined"
            class="source-img-bg"
          />
          <img class="source-img" v-lazy="src" />
        </div>
      </div>
      <div class="card-name" v-if="hasName">
        <p class="name">{{ name }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import { typeEnum } from "../../gameInfoConfig";
  export default {
    props: {
      type: {
        type: Number, //one of typeEnum
        default: 1,
      },
      quality: {
        type: String, //one of qulityEnum
        default: "R",
      },
      name: {
        type: String,
        default: "",
      },
      src: {
        type: String,
        default: "",
      },
      sourceBgType: {
        type: String | null | undefined,
        default: null,
      },
      hasName: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        classMap: {
          [typeEnum.TECHNICIAN]: "te-card",
          [typeEnum.MECH]: "mech-card",
          [typeEnum.WEAPON]: "weapon-card",
          [typeEnum.PACK]: "pack-card",
          [typeEnum.MODULE]: "module-card",
          [typeEnum.COMPONENT]: "component-card",
        },
      };
    },
    computed: {
      currentQulity() {
        switch (this.quality) {
          case "SSSR":
            return "exclusive";
          case "UR":
            return "best";
          case "SSR":
            return "best";
          case "SR":
            return "great";
          case "R":
            return "nice";
          case "C":
            return "normal";
        }
      },
      sourceBg() {
        switch (this.type) {
          case typeEnum.TECHNICIAN: {
            return "";
          }
          case typeEnum.MECH: {
            return "";
          }
          case typeEnum.WEAPON: {
            return "";
          }
          case typeEnum.PACK: {
            return "";
          }
          case typeEnum.MODULE: {
            if (this.sourceBgType) {
              switch (this.sourceBgType) {
                case "SuitA":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_suitA.png";
                case "SuitS":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_suitS.png";
                case "GeneralSuit":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_general_suit.png";
                case "PropertyA":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_propertyA.png";
                case "PropertyS":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_propertyS.png";
                default:
                  return "";
              }
            } else {
              return "";
            }
          }
          case typeEnum.COMPONENT: {
            if (this.sourceBgType) {
              switch (this.sourceBgType) {
                case "Condition":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_Condition.png";
                case "Function":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_Function.png";
                case "Condition2":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_Condition2.png";
                case "Function2":
                  return "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/stateType/statetype_Function2.png";
                default:
                  return "";
              }
            } else {
              return "";
            }
          }
          default: {
            return "";
          }
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .te-card,
  .mech-card,
  .weapon-card,
  .pack-card,
  .component-card,
  .module-card {
    position: relative;
    cursor: pointer;
  
    .best,
    .great,
    .nice,
    .normal {
      background-position: center;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
  
  //标题
  .te-card,
  .mech-card {
    .card-name {
      height: 0.42rem;
      width: 100%;
      position: absolute;
      bottom: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
  
      p {
        font-size: 0.24rem;
        max-width: 100%;
        padding: 0 0.3rem;
        text-align: center;
      }
    }
  }
  
  .weapon-card,
  .pack-card,
  .component-card,
  .module-card {
    .card-name {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.55rem;
  
      p {
        font-size: 0.2rem;
        text-align: center;
      }
    }
  }
  
  //背景图
  .te-card,
  .mech-card {
    .mask {
      position: absolute;
      top: 0.06rem;
      width: 1.93rem;
      height: 1.94rem;
      mask: url("../../../../../../assets/img/gl/gameInfo/game_info_mask.png");
      mask-size: contain;
      background-size: contain;
      left: 50%;
      transform: translate(-50%);
  
      img {
        user-select: none;
        -webkit-user-drag: none;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  
  .mech-card {
    img {
      object-position: 30%;
    }
  }
  
  .weapon-card,
  .pack-card,
  .component-card,
  .module-card {
    .simple-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
  
      .source-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        height: 80%;
        user-select: none;
        -webkit-user-drag: none;
        object-fit: contain;
      }
  
      .source-img-bg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        height: 80%;
        user-select: none;
        -webkit-user-drag: none;
        object-fit: contain;
      }
    }
  }
  
  //背景以及尺寸设定
  .te-card {
    .default-size {
      width: 2.01rem;
      height: 2.57rem;
    }
  
    .best,
    .great,
    .nice,
    .normal {
      width: 2.01rem;
      height: 2.57rem;
    }
  
    .best {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item1_qulity_3.png");
    }
  
    .great {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item1_qulity_2.png");
    }
  
    .nice {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item1_qulity_1.png");
    }
  }
  
  .mech-card {
    .default-size {
      width: 2.01rem;
      height: 2.57rem;
    }
  
    .best,
    .great,
    .nice,
    .normal {
      width: 2.01rem;
      height: 2.57rem;
    }
  
    .best {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item2_qulity_3.png");
    }
  
    .great {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item2_qulity_2.png");
    }
  
    .nice {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item2_qulity_1.png");
    }
  }
  
  .weapon-card {
    .default-size {
      width: 1.4rem;
      height: 1.4rem;
      background-size: contain;
    }
  
    .best,
    .great,
    .nice,
    .normal {
      width: 1.4rem;
      height: 1.4rem;
    }
  
    .exclusive {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_5.png");
    }
  
    .best {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_4.png");
    }
  
    .great {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_3.png");
    }
  
    .nice {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_2.png");
    }
  }
  
  .pack-card {
    .default-size {
      width: 1.4rem;
      height: 1.4rem;
      background-size: contain;
    }
  
    .best,
    .great,
    .nice,
    .normal {
      width: 1.4rem;
      height: 1.4rem;
    }
  
    .exclusive {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_5.png");
    }
  
    .best {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_4.png");
    }
  
    .great {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_3.png");
    }
  
    .nice {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_2.png");
    }
  
    .normal {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_1.png");
    }
  }
  
  .module-card {
    .source-img {
      transform: translate(-51%, -52%) rotate(16deg) !important;
      width: 48% !important;
      height: 48% !important;
    }
  
    .default-size {
      width: 1.4rem;
      height: 1.4rem;
    }
  
    .best,
    .great,
    .nice,
    .normal {
      width: 1.4rem;
      height: 1.4rem;
    }
  
    //TODO: 未出设计稿，临时
    .best {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_4.png");
    }
  
    .great {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_3.png");
    }
  
    .nice {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_2.png");
    }
  
    .normal {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_1.png");
    }
  }
  
  .component-card {
    //   .source-img {
    //     transform: rotate(30deg);
    //   }
  
    .source-img {
      transform: translate(-51%, -52%) rotate(16deg) !important;
      width: 48% !important;
      height: 48% !important;
    }
  
    .default-size {
      width: 1.4rem;
      height: 1.4rem;
    }
  
    .best,
    .great,
    .nice,
    .normal {
      width: 1.4rem;
      height: 1.4rem;
    }
  
    //TODO: 未出设计稿，临时
    .best {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_4.png");
    }
  
    .great {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_3.png");
    }
  
    .nice {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_2.png");
    }
  
    .normal {
      background-image: url("../../../../../../assets/img/gl/gameInfo/item_qulity_1.png");
    }
  }
  </style>
  